<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Expression logique</mat-label>
            <input matInput type="text" formControlName="expression" autocomplete="off" required (contextmenu)="$event.preventDefault(); onInputRightClick('expression', $event)" />
            <mat-error *ngIf="dataForm.controls['expression']?.errors?.required && (dataForm.controls['expression']?.dirty || dataForm.controls['expression'].touched)">
                Le champ 'Expression logique' est obligatoire
            </mat-error>
            <mat-error *ngIf="dataForm.controls['expression']?.hasError('invalidError')">
                <span title="Le champ doit respecter le format d'une expression logique.">
                    Expression logique inccorecte : {{ dataForm.controls['expression']?.errors['invalidError'] }}.
                </span>
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Expression logique" matTooltipPosition="right"></fa-icon>
    </div>
</form>
